import { useQuery } from "@tanstack/react-query"
import { useAppContext } from "../config/context"
import { useHeaders } from "./axios-headers"
import { extract } from "../client/backend-client/AxiosUtils"

export const useGetVintageThreshold = (entryDate: string) => {
  const { vintagesResourceApi } = useAppContext()
  const getHeaders = useHeaders()

  const { isLoading, data } = useQuery({
    queryKey: ["vintage", entryDate],
    queryFn: async () => {
      const { headers } = await getHeaders()
      return vintagesResourceApi
        .getCurrentVintageMinMaxDate({ entryDate }, { headers })
        .then(extract)
    },
    retry: 0,
    meta: {
      errorMessage: `Erreur lors de la récupération du millésime Accès +`
    }
  })

  return {
    isLoading,
    data
  }
}
